export const NO_RESULTS = 'NO_RESULTS';
export const API_ERROR = 'API_ERROR';
